
<div [ngClass]="{'blurbg' : isDialogOpen}" style="height: '100vh';">
    <app-navbar></app-navbar>
    
    <router-outlet></router-outlet>
</div>